import { makeStyles } from 'tss-react/mui';

export const useClientFormProgressStyles = makeStyles({ name: 'FormLineItem' })((theme) => ({
  itemText: {
    flex: 'unset',
    width: 'fit-content',
  },
  attentionChip: {
    background: theme.palette.warning.background,
    borderColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
  },
  attentionChipLabel: {
    padding: '0 10px'
  },
}));
